/* eslint react/jsx-no-target-blank: 0 */
import GreatSchoolLogo from '@/assets/greatschools/greatschools.png';
import { getRatingImage } from '@/components/GreatSchools/utils';
import { useAppContext } from '@/contexts/AppContext';
import { useNearbySchools } from '@/hooks/units';
import type { FC } from 'react';

type Props = {
  unitId: number;
};

const GreatSchools: FC<Props> = ({ unitId }) => {
  const { community } = useAppContext();
  const { data: schools } = useNearbySchools.useSuspenseQuery([community.id, unitId]);

  if (!schools?.length) {
    return null;
  }

  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Nearby Schools</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
        {schools.map((school) => (
          <div
            key={school.name}
            className="flex gap-3 m-3 pb-3.5 cursor-pointer border-b border-gray-200 sm:border-b-0 sm:border-r sm:last:border-r-0 md:last:border-r-0 md:[&:nth-child(3n)]:border-r-0"
            onClick={() => {
              window.open(school['overview-url'], '_blank');
            }}
          >
            <div>
              <img src={getRatingImage(school.rating_band)} alt={`${school.rating_band} rating`} />
            </div>
            <div className="flex-1 flex flex-col gap-3 pr-2">
              <div
                className="text-base font-medium leading-snug h-11 overflow-hidden text-ellipsis"
                style={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                }}
                data-school-name={school.name}
              >
                {school.name}
              </div>
              <span className="text-xs font-semibold">{school.distance.toFixed(2)} mi</span>
            </div>
          </div>
        ))}
      </div>
      <div className="my-2 flex items-center justify-end gap-3">
        <p className="text-sm" data-testid="about-greatschools">
          Data provided by{' '}
          <a
            className="text-black"
            href="https://www.greatschools.org/"
            target="_blank"
            rel="nofollow noreferrer"
          >
            <strong>GreatSchools.org</strong>
          </a>{' '}
          © {new Date().getFullYear()}. All rights reserved.
        </p>
        <a href="https://www.greatschools.org/" target="_blank" rel="nofollow noreferrer">
          <img src={GreatSchoolLogo} alt="GreatSchools.org" />
        </a>
      </div>
    </div>
  );
};

export default GreatSchools;
